module.exports = __webpack_public_path__ + "img/header-weddingRings.5d0048a.jpg";